import { render, staticRenderFns } from "./conflict.vue?vue&type=template&id=51da0248&"
import script from "./conflict.vue?vue&type=script&lang=js&"
export * from "./conflict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports